import { orderBy, split, get, toLower, includes } from 'lodash/fp';

const getSortColumn = (column, { guest = null }) =>
  includes(column, ['firstName', 'lastName']) && guest
    ? `guest.${toLower(column)}`
    : column;

export default (order, reservations) => {
  const [sortBy, sortOrder] = split(':', order);

  return orderBy(
    each => {
      const column = getSortColumn(sortBy, each);
      return column === 'guestId'
        ? get(column, each) || 0
        : toLower(get(column, each));
    },
    sortOrder,
    reservations
  );
};
